import React, { useState } from 'react';
import classes from './SmoFoldList.module.css';
import {Typography, Paper} from '@mui/material';
import IconButton from '@mui/material/IconButton';
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';
import KeyboardArrowUpRoundedIcon from '@mui/icons-material/KeyboardArrowUpRounded';


const SmoFoldList = props => {
    const [open, setOpen] = useState(false);
    const listOpenHandler = () => {
        setOpen(() => !open);
    }

    return (
        <Paper className={classes.foldlist} elevation={1} sx={{padding: "10px"}}>
            <div className={classes['foldlist-title']} onClick={listOpenHandler}>
                <Typography variant="description" component="span" className={classes['foldlist-title--text']} style={{...props.titleSx}}>{props.title}</Typography>
                <IconButton className={classes["foldlist-title--icon"]} onClick={listOpenHandler}>
                    {open ? <KeyboardArrowUpRoundedIcon /> : <KeyboardArrowDownRoundedIcon/>}
                </IconButton>
            </div>
            <div className={`${classes['foldlist-subtitle']} ${open ? classes.active : ''}`} >
                <Typography variant="subtitle1" component="span">{props.subtitle}</Typography>
                <table className={classes.table}>
                    <thead>
                        <tr>
                            {props.thead.map(tableHead => (
                            <th key={tableHead}><Typography variant="subtitle2">{tableHead}</Typography></th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {
                        props.data.map((data, index) => (
                            <tr key={index}>
                                {data.map((secondData, secondIndex) => (
                                    <td key={secondIndex}>{secondData}</td>
                                ))}
                            </tr>
                        ))
                        }
                    </tbody>
                </table>
            </div>
        </Paper>
    )
}

export default SmoFoldList;